module.exports = __webpack_public_path__ + "img/landing-invest-news.e3f4679c.svg";